import { render, staticRenderFns } from "./FeedManagement.vue?vue&type=template&id=48147f92"
import script from "./FeedManagement.js?vue&type=script&lang=js&external"
export * from "./FeedManagement.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports